import { useContactManagementTranslation } from '../../../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Alert, Box, Typography } from '@mui/material';
import React from 'react';
export const OrganizationWithExceededLimitConfirmDialog = ({ orgWithExceededLimit, }) => {
    const { t } = useContactManagementTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { backgroundColor: themeColors.surface.secondary, p: 2, mb: 2 } },
            React.createElement(Typography, { sx: { mb: 2 } }, t('publicSelfRegistration.membership.limitExceededExplanation')),
            React.createElement(DataTable, { loading: false, rows: orgWithExceededLimit, columns: [
                    {
                        headerLabel: t('publicSelfRegistration.membership.cannotBeAddedTo'),
                        cellField: 'name',
                    },
                ] })),
        React.createElement(Alert, { severity: 'info' }, t('publicSelfRegistration.membership.orgWillBeAdded'))));
};
